import { createSelector } from 'reselect';
import { getFields } from '../selectors/fields';
import fieldVisibilityRules from '../selectors/reportsConfig/fieldVisibilityRules';
import { getAdminModeEnabled, getUserData } from '../selectors/user';
import { sortAlphabetically } from '../utils/sortUtil';
import { HARDCODED_FIELDS } from './consts';
import { getDimensionAvailabilityTypesWhitelist } from './utils';
import { getIsAdvanceMode, getSelectedSources } from '../selectors/reports';

export const getVisibleFields = reportType =>
    createSelector(
        [getFields, getAdminModeEnabled, getUserData, getIsAdvanceMode(reportType), getSelectedSources(reportType)],
        (fields, adminModeEnabled, userData, isAdvanceMode, selectedSources) => {
            const dimensionTypes = getDimensionAvailabilityTypesWhitelist(reportType);

            return Object.keys(fields)
                .filter(key => {
                    return dimensionTypes.includes(key);
                })
                .reduce((acc, key) => {
                    const relevantFields = fields[key];

                    if (!relevantFields?.length) return acc;

                    const filteredFields = relevantFields.concat(HARDCODED_FIELDS[key] || []).filter(field => {
                        return (
                            !reportType ||
                            fieldVisibilityRules[reportType](
                                field,
                                false,
                                userData,
                                false,
                                isAdvanceMode,
                                selectedSources
                            )
                        );
                    });

                    return acc.concat(filteredFields);
                }, [])
                .sort(({ display_name: displayName1 }, { display_name: displayName2 }) =>
                    sortAlphabetically(displayName1, displayName2)
                );
        }
    );
